export default {
  EmptyState: {
    title: 'Aggiungi il tuo primo ristorante',
    description: 'Non hai ancora nessun ristorante. Creane uno per iniziare la configurazione e ricevere ordini.',
    cta: 'Nuovo ristorante',
  },
};
